import { observable } from "mobx";
import { Type } from "class-transformer";
import PaginationResponse from "./paginationResponse";
import AccountingDocumentsInventoriesPermittedActionsResponse from "./accountingDocumentsInventoriesPermittedActionsResponse";
import AccountingDocumentsInventoryResponse from "./accountingDocumentsInventoryResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class AccountingDocumentsInventoriesResponse {
  @observable
  @Type(() => PaginationResponse)
  metadata!: PaginationResponse;

  @observable
  @Type(() => AccountingDocumentsInventoriesPermittedActionsResponse)
  permittedActions!: AccountingDocumentsInventoriesPermittedActionsResponse;

  @observable
  @Type(() => AccountingDocumentsInventoryResponse)
  items!: AccountingDocumentsInventoryResponse[];
}
